var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10077",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2323 0V30.5864H0.169922V0H32.2323V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10077)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4919 9.52386L31.4179 10.9659C32.1973 11.0792 32.5085 12.0372 31.9443 12.5868L24.7621 19.5877L26.4575 29.4735C26.5906 30.2494 25.7762 30.8414 25.0789 30.4751L16.2013 25.8075L7.32337 30.4751C6.62607 30.8414 5.81165 30.2494 5.94474 29.4735L7.64011 19.5877L0.45794 12.5868C-0.105944 12.0372 0.204934 11.0792 0.984375 10.9659L10.9103 9.52386L15.3491 0.529483C15.6978 -0.17682 16.7045 -0.17682 17.0532 0.529483L21.4919 9.52386V9.52386Z",
    fill: "#9CA1B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a8c13cbe4d5ad71370c655356838c850.svg";
export { ForwardRef as ReactComponent };